import createIcon from '../../createIcon';

/**
 * @component @name AlignVerticalCenter
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuMDc5OSAxMUgxNy4wNzk5VjZIMTQuMDc5OVYxMUgxMC4wNzk5VjNINy4wNzk5MlYxMUgxLjkxOTkyVjEzSDcuMDc5OTJWMjFIMTAuMDc5OVYxM0gxNC4wNzk5VjE4SDE3LjA3OTlWMTNIMjIuMDc5OVYxMVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignVerticalCenter = createIcon('AlignVerticalCenter', [
  [
    'path',
    {
      d: 'M22.0799 11H17.0799V6H14.0799V11H10.0799V3H7.07992V11H1.91992V13H7.07992V21H10.0799V13H14.0799V18H17.0799V13H22.0799V11Z',
      key: '105t9z',
    },
  ],
]);

export default AlignVerticalCenter;
